import React from "react"
import Layout from "../components/App/Layout"
import Navbar from "../components/App/Navbar"
// import PageBanner from '../components/Common/PageBanner'; // <-- Remove this line
import Footer from "../components/App/Footer"
import SEO from "../components/App/SEO"

import ai_image from "../assets/images/iot_image.png"
import ai_banner2 from "../assets/images/iot_banner.png"
import ai_banner3 from "../assets/images/iot_banner.png"
import iot_1 from "../assets/images/iot1.png"
import iot_2 from "../assets/images/iot2.png"
import iot_3 from "../assets/images/iot3.png"
import Custom_aps from "../assets/images/IOT_app.png"
import data_preparation from "../assets/images/IOT_plateform.png"
import Industry_pecific from "../assets/images/Flexible_IOT.png"
import Integration from "../assets/images/IOT_Support.png"
import Ongoing_support from "../assets/images/IOT_devices.png"
import Text_image from "../assets/images/Hardware_con_api.png"

// Add these imports at the top with other image imports
import step1_icon from "../assets/images/step1.png"
import step2_icon from "../assets/images/step2.png"
import step3_icon from "../assets/images/step3.png"
import step4_icon from "../assets/images/step4.png"
import step5_icon from "../assets/images/step5.png"
import step6_icon from "../assets/images/step6.png"

import Agriculture from "../assets/images/agri_iot.png"
import Automotive from "../assets/images/env_moni.png"
import Education from "../assets/images/Education.png"
import Energy from "../assets/images/smart_enegry.png"
import Finance from "../assets/images/smart-city.png"
import Government_public_sector from "../assets/images/Travel_&_Hospitality.png"
import Healthcare from "../assets/images/health_iot.png"
import Legal_compliance from "../assets/images/on_dem_ser.png"
import Logistics from "../assets/images/smart-sensors.png"
import Manufacturing from "../assets/images/Manufacturing.png"
import Media from "../assets/images/smart-lock.png"
import Retail from "../assets/images/smart-retail.png"
import Swal from 'sweetalert2';
import consistent from '../assets/images/consistent.png';
import phonecall from '../assets/images/phonecall.png';
import FunfactComponent from "../components/DynamicPages/FunfactComponent"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

// alert('sent successfully');
const sendEmail = async (e) => {
  e.preventDefault()
  // alert('sent successfully');

  const messageBody = `

  Hi,
  
  Name: ${e.target.elements.name.value}
  Phone No: ${e.target.elements.email.value}
  Message: ${e.target.elements.message.value}
  technology:${e.target.elements.technology.value}
  `
  console.log(messageBody);
  try {

    const response = await fetch('https://p8t29dandg.execute-api.ap-south-1.amazonaws.com/prod', {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "no-cors", // no-cors, cors, *same-origin
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: e.target.elements.email.value, messageBody },), // body data type must match "Content-Type" header
    }).then(() => Swal.fire(
      'Mail Sent Successfully!',

    )
    )
    window.location.reload(false);
    ;
    // const json = await response.json()

  } catch (error) {
    console.log(error);
  }
}
const services = [
  {
    title: "IoT Application Development",
    text: "The Internet of Things (IoT) system is essential for increasing business intelligence. We can create new and diverse IoT applications while maintaining high security.",
    icon: Custom_aps,
  },
  {
    title: "Hardware connect API Development",
    text: "We design and develop a wide range of applications for the Android mobile platform, taking advantage of current trends and technology. We have the knowledge and experience to develop APIs.",
    icon: Text_image,
  },
  {
    title: "Flexible IoT Models",
    text: "We can create IoT programs that are adaptable to your requirements.",
    icon: Industry_pecific,
  },
  {
    title: "IoT support & Help",
    text: "We will always be available to assist and support you in accordance with your needs.",
    icon: Integration,
  },
  {
    title: "IoT Platform for Future",
    text: "The Internet of Things (IoT) will be huge in the future. As a result, you can use our team's expertise to build your products on the IoT platform.",
    icon: data_preparation,
  },
  {
    title: "Wear IoT devices",
    text: "Our team of IoT developers will assist in the development of products that will be linked to wearables in the future.",
    icon: Ongoing_support,
  },
]

const industries = [
  {
    title: "Smart Cities",
    icon: Finance,
  },
  {
    title: "Industrial IoT",
    icon: Manufacturing,
  },
  {
    title: "Smart Home",
    icon: Media,
  },
  {
    title: "Smart Retail",
    icon: Retail,
  },
  {
    title: "Agricultural IoT",
    icon: Agriculture,
  },
  {
    title: "On-Demand Service",
    icon: Legal_compliance,
  },
  {
    title: "Smart Energy",
    icon: Energy,
  },
  {
    title: "Healthcare IoT",
    icon: Healthcare,
  },
  {
    title: "Environmental Monitoring",
    icon: Automotive,
  },
  {
    title: "Smart Sensors",
    icon: Logistics,
  },
  {
    title: "Education & eLearning",
    icon: Education,
  },
  {
    title: "Travel & Hospitality",
    icon: Government_public_sector,
  },
]

// Update the executionSteps array to include icons
const executionSteps = [
  { text: "Project Initiation & Goal Definition", icon: step1_icon },
  { text: "Planning & Strategy", icon: step2_icon },
  { text: "Execution & Task Management", icon: step3_icon },
  { text: "Monitoring Control", icon: step4_icon },
  { text: "Quality Assurance & Testing", icon: step5_icon },
  { text: "Closure & Review", icon: step6_icon },
]

const faqData = [
  {
    question: "What AI development services do you offer?",
    answer:
      "We offer services like natural language processing, machine learning model development, computer vision, AI consulting, and custom AI solution development.",
  },
  {
    question: "How can AI benefit my business?",
    answer:
      "AI can streamline operations, improve customer service, provide predictive analytics, and automate routine tasks, increasing overall efficiency and innovation.",
  },
  {
    question: "What industries do you specialize in?",
    answer:
      "We specialize in healthcare, finance, e-commerce, manufacturing, and logistics, among other industries.",
  },
]

const IotDevelopment = () => {
  // Removed unused openIndex and setOpenIndex state

  // const toggleIndex = (index) => { // <-- Remove this function
  //   setOpenIndex(openIndex === index ? null : index);
  // };

  return (
    <Layout>
      <SEO
        title="IoT Application Development Services | Internet of Things Solutions | SrashtaSoft"
        description="SrashtaSoft is a leading IoT development company offering robust, scalable software ecosystems for connected devices, cloud integration, and firmware development."
        canonical="https://srashtasoft.com/iot-development/"
        isServicePage
        serviceName="IoT Application Development Services"
        faqData={faqData}
      />
      <Navbar />

      {/* Hero Section */}
      <section
        className="hero-section bg-overlay"
        style={{
          background: `url(${ai_image}) no-repeat center center/cover`,
          height: "500px",
          color: "white",
          display: "flex",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.5)"
        }}
      >
        <div
          className="d-flex align-items-center w-100"
        >
          <div className="container">
            <div className="row">
              <div className="col-md-9">
                <h2 className="fw-bold">
                  Empowering Tomorrow's <br />
                  Connected World
                </h2>
                <p className="mt-3 text-white">
                  A cutting-edge IoT solution demands a robust, scalable
                  software <br /> ecosystem that fully leverages your advanced
                  embedded hardware <br /> while delivering a seamless user
                  experience
                </p>
                <a href="/contact-us" className="btn btn-custom mt-4">Let’s talk Now!</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-md-6">
              <div className="row">
                <div className="col-6">
                  <img
                    src={iot_1}
                    loading="lazy"
                    className="img-fluid rounded shadow"
                    alt="Generative AI Illustration 1"
                  />
                </div>
                <div className="col-6">
                  <img
                    src={iot_2}
                    loading="lazy"
                    className="img-fluid rounded shadow"
                    alt="Generative AI Illustration 2"
                  />
                </div>
                <div className="col-12 pt-4">
                  <img
                    src={iot_3}
                    loading="lazy"
                    className="img-fluid rounded shadow"
                    alt="Generative AI Illustration 3"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <h2 className="h1 fw-bold text-headings mb-4">
                Partner with a top IoT <br /> software development company to
                bring your product to life.
              </h2>
              <p className="text-secondary mb-3">
                A powerful embedded hardware system demands a robust and
                scalable software solution to unlock its full potential and
                deliver a seamless user experience. By partnering with Excellent
                Web world, you can enjoy effortless usability, unmatched
                adaptability, secure connectivity, and seamless interoperability
                ensuring that future upgrades become a smooth transition for
                your project.
              </p>
              <p className="text-secondary mb-4">
                Whether you’re in need of a standalone service—covering areas
                like technical feasibility, device connectivity, firmware
                development, cloud integration, or connected mobile application
                development—or seeking a comprehensive suite of IoT software
                development services, our expertise spans every facet to support
                your innovation.
              </p>
              <a href="/contact-us" className="btn btn-white px-4 py-2" style={{
                color: "#1A2B5F",
                border: "0.6px solid #1A2B5F",
                textDecoration: "none" // optional, to remove underline
              }}>
                Let’s talk IoT development
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Banner CTA */}
      <section
        className="py-5 bg-blue-500 text-white position-relative"
        style={{
          background: `url(${ai_banner2}) no-repeat center center/cover`,
          height: "350px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 72, 186, 0.85)", // Changed to a more solid blue overlay
            zIndex: 1,
          }}
        ></div>

        <div
          className="container d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start"
          style={{ position: "relative", zIndex: 2 }}
        >
          <h2 className="h3 fw-bold mb-4 mb-md-0" style={{ fontSize: "46px" }}>
            Looking to build an <br />
            IOT product in the industry?
            <br />
            We’ve done it before
          </h2>
          <a
            href="/contact-us"
            className="btn btn-light fw-semibold text-dark"
            style={{
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "24px",
              letterSpacing: "2%",
              width: "180PX",
              height: "56",
              borderRadius: "6px",
            }}
          >
            Let’s talk Now!
          </a>
        </div>
      </section>

      {/* Services */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2
            className="mb-5 fw-bold"
            style={{ color: "#1A2B5F", fontSize: "40px" }}
          >
            IOT Development
          </h2>
          <div className="row g-4">
            {services.map((service, index) => (
              <div
                className="col-md-4 col-lg-4"
                key={index}
                style={{ marginTop: "30px" }}
              >
                <div className="card h-100 shadow-sm">
                  <div className="card-body">
                    <img
                      src={service.icon}
                      loading="lazy"
                      className="mb-3"
                      alt={service.title}
                      style={{ width: "40px", height: "40px", objectFit: "contain" }}
                    />
                    <h5 className="card-title">{service.title}</h5>
                    <p className="card-text text-muted">{service.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries */}
      <section className="py-5 bg-white">
        <div className="container text-center">
          <h2 className="fw-bold mb-4" style={{ color: "#1A2B5F" }}>
            Industries We Serve
          </h2>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-6 g-4">
            {industries.map((industry, index) => (
              <div
                className="col"
                key={index}
                style={{
                  height: "160px !important",
                  marginTop: "24px",
                }}
              >
                <div
                  className="p-4 shadow-sm h-100 text-center"
                  style={{ borderRadius: "12px", border: "1px solid #E3E3E3" }}
                >
                  <img
                    src={industry.icon}
                    alt={industry.title}
                    className="mb-3"
                    loading="lazy"
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "contain",
                    }}
                  />
                  <h5 className="fw-semibold font_size mb-2">
                    {industry.title}
                  </h5>
                  <p className="text-muted small mb-0">{industry.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Execution Steps */}
      <section
        className="bg-primary text-white py-5"
        style={{
          background: `url(${ai_banner3}) no-repeat center center/cover`,
          height: "660px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",  // Added for overlay positioning
        }}
      >
        {/* Add overlay div */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 72, 186, 0.85)",
            zIndex: 1,
          }}
        ></div>

        <div
          className="container text-center"
          style={{
            height: "663px",
            alignContent: "center",
            position: "relative",  // Added for z-index to work
            zIndex: 2,  // Added to place content above overlay
          }}
        >
          <h2
            className="fw-bold mb-5"
            style={{
              fontWeight: 700,
              fontSize: "40px",
              lineHeight: "40px",
              letterSpacing: "2%",
              textAlign: "center",
              textTransform: "capitalize",
            }}
          >
            How We Execute Your Project
          </h2>
          <div
            className="row justify-content-center gy-4"
            style={{ height: "313px" }}
          >
            {executionSteps.map((step, index) => (
              <div
                className="col-6 col-sm-4 col-md-2"
                key={index}
                style={index % 2 !== 0 ? { marginTop: "70px" } : {}}
              >
                <div className="d-flex flex-column align-items-center">
                  <img
                    src={step.icon}
                    alt={step.text}
                    className="mb-3"
                    style={{
                      width: "155px",
                      height: "155px",
                      objectFit: "contain",
                    }}
                  />
                  <p
                    className="fw-semibold small text-white mb-0"
                    style={{
                      fontWeight: 700,
                      fontSize: "16px",
                      lineHeight: "24px",
                      letterSpacing: "4%",
                      textAlign: "center",
                      verticalAlign: "middle",
                      textTransform: "capitalize",
                    }}
                  >
                    {step.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-5 bg-white">
        <div className="container">
          <h2
            className="text-center fw-bold mb-4"
            style={{
              fontWeight: 700,
              fontSize: "40px",
              lineHeight: "100%",
              letterSpacing: "0%",
              textTransform: "capitalize",
            }}
          >
            FAQs: Internet of Things (IoT) Development Services
          </h2>

          <div className="panel-group wrap" id="bs-collapse">

            <Accordion allowZeroExpanded>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What is IoT, and how does it work?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    IoT (Internet of Things) refers to a network of physical devices embedded with sensors, software, and connectivity that allow them to collect and exchange data. These devices communicate through the internet to monitor, automate, and optimize processes in real time.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What are the key benefits of implementing IoT in business?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    IoT improves efficiency, reduces operational costs, enhances real-time monitoring, and enables predictive maintenance. It helps businesses automate manual tasks, gain actionable insights, and make data-driven decisions for better productivity and customer experience.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What industries can benefit from IoT solutions?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    IoT is used across various industries including manufacturing, healthcare, agriculture, logistics, smart homes, energy, and retail. It helps in asset tracking, remote monitoring, smart energy management, supply chain optimization, and improving product quality.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Is my data safe with IoT systems?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes. We implement enterprise-grade security with data encryption, secure APIs, user authentication, and regular audits to protect your data. Our solutions follow industry best practices to ensure the safety and integrity of your connected systems.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    How long does it take to develop and deploy an IoT solution?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Project duration depends on the complexity and requirements. A basic IoT prototype can take 3–6 weeks, while a full-scale deployment with hardware integration, cloud setup, and analytics dashboard may take 8–16 weeks.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>
      <FunfactComponent />
      <section className='need-help-section' id='need-help'>
        <div className='container'>
          <div className='row quote-formss'>
            <div className='col-lg-6 col-md-12'>
              <h1>NEED HELP ?</h1>
              <p className='need-paragraph'>Choosing The Right Package</p>
              <div className='row padding-class'>
                <div className='col-md-6'>
                  <div class="icon-need-div">
                    <div class="icon">
                      <img src={consistent} />
                    </div>
                    <p className='normal-p'>	Contact a <strong class="yello-colors"> IOT Development</strong></p>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div class="icon-need-div">
                    <div class="icon">
                      <img src={phonecall} />
                    </div>
                    <p className='normal-p'>	<a classname="ancher-link" href="tel:+(91) 9898582705">Schedule <strong class="yello-colors"> a call with us  </strong></a></p>
                  </div>
                </div>

              </div>
              <span className='heading-text'>+(91) 9898582705</span>
            </div>
            <div className='col-lg-2 col-md-0'></div>
            <div className='col-lg-4 col-md-12'>
              <section id="quote" className="bg-msar msar-quote-form">
                <section className="row">
                  <form onSubmit={sendEmail}>

                    <div className="col-md-12">
                      <div className="mt-4 white-text">Get Your Free</div>
                      <h4 className='white-text'>Consultation &amp; Quote</h4>
                      <div id="frm-quote">
                        <div className="form-group mt-4">
                          <input type="text"
                            className="form-control w-100 border-0"
                            placeholder="Name*"
                            name="name"
                            required
                          // onChange={onInputchange}
                          />
                        </div>

                        <div className="form-group">
                          <input type="text"
                            className="form-control w-100 border-0"
                            placeholder="Email*"
                            name="email"
                            required
                          // onChange={onInputchange}
                          />
                        </div>

                        <div className="form-group">
                          <select class="form-control w-100 border-0 p-2 " name='technology'
                          //  onChange={onInputchange}
                          >
                            <option value="Service">Service Required </option>
                            <option value="ReactJs">ReactJs Development</option>
                            <option value="NodeJs">NodeJs Developement</option>
                            <option value="WordPress">WordPress Development</option>
                            <option value="PHP">PHP Development</option>
                            <option value="Laravel">Laravel Development</option>
                            <option value="Flutter">Flutter Development</option>
                            <option value="Reactnative">React Native Development</option>
                            <option value="Android">Android Development</option>
                            <option value="IOS">IOS Development</option>
                            <option value="graIOTpefruit">IOT Development</option>
                            <option value="UIUX">UI/UX Development</option>
                            <option value="Shopify">Shopify Development</option>
                            <option value="Magento">Magento Development</option>
                            <option value="Layout">Layout Design</option>
                            <option value="Html">Html Development</option>
                            <option value="Logo">Logo Design</option>
                            <option value="Python">Python Development</option>
                          </select>
                        </div>

                        <div className="form-group mb-0">
                          <textarea className="form-group w-100 border-0 p-2 mb-0"
                            rows="2"
                            placeholder="Your Text"
                            // onChange={onInputchange}
                            name="message"
                            required
                          >
                          </textarea>
                        </div>

                        <div className="mt-0 pt-0 small white-text">* Need to fill marked. Make a call more details required.</div>
                        <button type="submit" className="btn-white-custom btn btn-sm mt-3"> Send Message </button>
                      </div>
                    </div>
                  </form>
                </section>
              </section>
            </div>

          </div>
        </div>
      </section>
      <Footer />
    </Layout>
  )
}

export default IotDevelopment
